<template>
    <div>
        <Header/>
        <section class="section">
            <div class="container">
                <h1 class="title has-text-centered">Мы не нашли то, что вы искали.</h1><br/>
                <h2 class="subtitle has-text-centered">Попробуйте изменить критерии поиска или оформите заявку
                    ниже<br/></h2>
                <h3 class="has-text-centered">
                    <small class="is-centered">После оформления заявки наши специалисты свяжутся с Вами и организуют
                        поставку из любой точки мира по самым выгодным условиям. С гарантией!
                    </small>
                </h3>
                <section class="section">
                    <div class="columns">
                        <div class="column is-4 has-text-centered">
                            <img src="../../assets/images/laptop_not_found.png">
                        </div>
                        <div class="column">
                            <table>
                                <tbody>
                                    <tr>
                                        <td colspan="2">
                                            <b-field>
                                                <b-input type="textarea"
                                                         v-model="personal_data.comments"
                                                         minlength="5"
                                                         maxlength="500"
                                                         placeholder="Здесь вы можете оставить свои комментарии">
                                                </b-input>
                                            </b-field>
                                        </td>
                                    </tr>
                                    <tr v-if="showForm">
                                        <td colspan="2">
                                            <b-field label="Ваше Имя" type="is-success">
                                                <b-input placeholder="Введите ваше имя сюда"
                                                         v-model="personal_data.name"
                                                         autofocus></b-input>
                                            </b-field>
                                            <b-field grouped>
                                                <b-field label="Код" type="is-success">
                                                    <b-input :value="'+998'" disabled></b-input>
                                                </b-field>
                                                <b-field label="Номер" type="is-success" expanded>
                                                    <b-input type="number" v-model="personal_data.phone"
                                                             placeholder="К примеру: 90 911 22 44"></b-input>
                                                </b-field>
                                            </b-field>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </section>
            </div>
        </section>
    </div>
</template>

<script>
    import Header from "../components/header/Header";
    export default {
        name: "NotFound",
        components: {Header},
        data() {
            return {
                personal_data: {
                    name: '',
                    phone: '',
                    comments: ''
                }
            }
        }
    }
</script>

<style scoped>

</style>